const ControlVisiblePages = (path: string, visiblePages: any) => {
  const correctPath = path?.slice(1)
  const check = visiblePages?.some((item: any) => item?.full_path === correctPath)
  return check
}

export default ControlVisiblePages
